import postal_code from 'japan-postal-code';

const zip_input = document.querySelector('input[name="郵便番号"]');
const pref_input = document.querySelector('select[name="都道府県"]');
const address_input = document.querySelector('input[name="市区町村・番地"]');

(function(){
  if(!zip_input) return false;

  zip_input.addEventListener('keyup', function(e){
    const code = this.value.replace(/\-/g,'');
    if(code.length != 7 ) return;
    postal_code.get(code, function(address) {
      pref_input.value = address.prefecture;
      address_input.value = address.city+address.area+address.street;
    });
  })

})();
